<template>
  <div>
    <v-row no-gutters class="mb-8 px-8">
      <v-col xs="0" sm="0" md="0" lg="1" xl="1"/>
      <v-col xs="12" sm="12" md="12" lg="10" xl="10" class="pt-8 d-flex flex-column">
        <v-row class="d-flex pb-8">
          <v-col class="d-flex justify-center text-h3 font-weight-light text-center">
            {{ $t('title.cashflow') }}
          </v-col>
          <v-col v-if="false" cols="2" class="font-weight-light">
            <!-- {{ now }} -->
          </v-col>
        </v-row>

        <v-card
          v-if="maturities.length"
          class="mb-12"
          outlined
          style="height: 30vh; background-color: #121212;"
        >
          <v-chart class="chart" autoresize :option="maturitiesChart" />
        </v-card>

        <v-card outlined style="height: 75vh; background-color: #121212;" class="mb-4">
          <v-data-table 
            v-if="formattedMaturities.length"
            style="max-height: calc(75vh - 87px); overflow-y: auto; background-color: #121212;"
            item-key="Date"
            :headers="cashFlowHeaders"
            :items="formattedMaturities"
            hide-default-header
            hide-default-footer
            disable-pagination
            
          >
            <template v-slot:header="{ props }">
              <thead >
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.value"
                    class="text-center white--text"
                    style="background-color: #2a2a2a; font-size: 15px"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr>
                <td class="text-center">
                  {{ props.item.formattedDate }}
                </td>

                <td class="text-center">
                  {{ props.item.Description }}
                </td>

                <td class="text-center">
                  {{ props.item.Currency }}
                </td>

                <td class="text-center"
                style="color: #FFC107">  
                  {{ props.item.receivable }}
                </td>

                <td class="text-center"
                style="color: #FF6D00">
                  {{ props.item.payable }}
                </td>
              </tr>
            </template>
          </v-data-table>

          <div v-else class="d-flex justify-center mb-10 mt-2">
            <span class="text-h5">
              {{ $t('cashFlow.imputFileMessage') }}
            </span>
          </div>
          <div class="d-flex mt-6 mx-4 my-4">
            <v-file-input 
              v-model="maturitiesCsvModel"
              :label="$t('cashFlow.inputPlaceHolder')"
              :placeholder="$t('cashFlow.inputPlaceHolder')"
              :value="maturitiesCsv"
              accept="txt/*,.csv"
              prepend-icon="mdi-calendar"
              class="mb-4 mr-4"
              color="primary"
              style="width: 350px; max-width: 350px;"
              width="350"
              :disabled="loadingPut || loadingGet"
              single-line
              hide-details
              dense 
              @change="changeFile($event)"
            > 
            </v-file-input>
            
            <v-btn 
              outlined 
              color="primary" 
              small
              :loading="loadingPut"
              :disabled="loadingGet || !maturitiesCsvModel"
              @click="showDialog()"
            >
              {{ $t('instructions.import') }}
            </v-btn>

            <div class="ml-4">
              <v-btn 
                outlined 
                color="primary" 
                small
                :loading="loadingDownload"
                :disabled="loadingGet || loadingPut || !maturities.length"
                @click="exportCurrencyMaturities()"
              >
              {{ $t('instructions.export') }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col xs="0" sm="0" md="0" lg="1" xl="1"/>
    </v-row>

    <v-dialog
      v-model="dialog"
      width="400"
      content-class="border-dialog"
      persistent
    >
      <v-card>
        <v-card-title>
          <div class="headline primary--text">
            {{ $t('extras.warning')}}
          </div>
        </v-card-title>

        <v-card-text>
          <div style="display: flex; flex-direction: column">
            {{ $t('cashFlow.warning')}}
          </div>
        </v-card-text>

        <v-card-text v-if="loadingPut" class="d-flex justify-center">
          <loading-custom></loading-custom>
        </v-card-text>

        <v-card-text v-if="uploadSuccess" class="d-flex justify-center">
          <v-icon style="font-size: 110px">
            mdi-check
          </v-icon>
        </v-card-text>

        <v-card-text v-if="uploadSuccess === false" class="d-flex justify-center">
          <v-icon
            style="font-size: 110px"
          >
            mdi-close
          </v-icon>
        </v-card-text>

        <v-divider v-if="!loadingPut && uploadSuccess === undefined"/>

        <v-card-actions v-if="!loadingPut && uploadSuccess === undefined">
          <v-spacer/>
          <v-btn
            text
            @click="csvFile = undefined, dialog = false"
          >
            {{ $t('instructions.cancel')}}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="importMaturities()"
          >
            {{ $t('instructions.confirm')}}
          </v-btn>
        </v-card-actions>

        <v-divider v-if="!loadingPut && uploadSuccess !== undefined"/>

        <v-card-actions v-if="!loadingPut && uploadSuccess !== undefined">
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="dialog = false; uploadSuccess=undefined;"
          >
            {{ $t('extras.ok')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar 
      v-model="snackbarError" 
      :timeout="7000" 
      bottom
      color="error"
    >
      {{ snackbarMsg }}

      <template v-slot:action="{ attrs }">
        <v-btn 
          text 
          v-bind="attrs"
          @click="snackbarError = false"
        > 
          {{ $t('extras.ok')}}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar 
      v-model="snackbarSuccess" 
      :timeout="4000" 
      bottom
      color="alive"
    >
      {{ $t('cashFlow.importSuccess')}}

      <template v-slot:action="{ attrs }">
        <v-btn 
          text 
          v-bind="attrs"
          @click="snackbarSuccess = false"
        > 
          {{ $t('extras.ok')}}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapWritableState, mapActions } from "pinia"
import { useSettingsStore, useRiskStore } from "./../store/index"
import LoadingCustom from './../components/hedge/LoadingCustom'
import VChart from "vue-echarts"
import { use } from 'echarts/core'
import { BarChart } from 'echarts/charts'
import { TooltipComponent, GridComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

use([
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer
])

export default {
  components: {
    LoadingCustom,
    VChart,
  },
  data () {
    return {
      cashFlowHeaders: [
        { text: this.$t('extras.date'), value: "Date", align: "center", width: "20%"},
        { text: this.$t('cashFlow.table.description'), value: "Description", align: "center", width: "30%" },
        { text: this.$t('cashFlow.table.ccy'), value: "Currency", align: "center", width: "10%" },
        { text: this.$t('cashFlow.table.receivable'), value: "receivable", align: "center", width: "20%" },
        { text: this.$t('cashFlow.table.payable'), value: "payable", align: "center", width: "20%" },
      ],
      maturitiesCsvModel: undefined,
      loadingDownload: false,
      snackbarError: false,
      snackbarSuccess: false,
      snackbarMsg: "",
      maturitiesCsv: undefined,
      loadingPut: false,
      loadingGet: false,
      dialog: false,
      uploadSuccess: undefined,
    }
  },
  computed: {
    ...mapState(useSettingsStore, [
      "isMockDataOn"
    ]),
    ...mapState(useRiskStore, [
      'maturities',
      'formattedMaturities'
    ]),
    ...mapWritableState(useRiskStore, [
      'maturities',
    ]),
    maturitiesChart() {
      const grouped = {}

      this.maturities.forEach(item => {
        const date = item.Date
        const amount = parseFloat(item.Amount) || 0

        if (!grouped[date]) {
          grouped[date] = { pos: 0, neg: 0 }
        }

        if (amount >= 0) {
          grouped[date].pos += amount
        } else {
          grouped[date].neg += amount
        }
      })

      const groupedMaturities = Object.entries(grouped)
        .map(([date, { pos, neg }]) => ({ date, pos, neg }))
        .sort((a, b) => new Date(a.date) - new Date(b.date))

      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            const dataIndex = params[0].dataIndex
            const item = groupedMaturities[dataIndex]
            const [year, month, day] = item.date.split('-')
            const formattedDate = `${day}/${month}/${year}`

            return `
              <strong>${this.$t('extras.date')}:</strong> ${formattedDate}<br />
              <strong>${this.$t('cashFlow.table.receivable')}:</strong> ${item.pos}<br />
              <strong>${this.$t('cashFlow.table.payable')}:</strong> ${item.neg}<br />
            `
          },
        },
        xAxis: {
          type: 'category',
          data: groupedMaturities.map(item => item.date),
          axisLabel: {
            color: '#ffffff',
            formatter: (value) => {
              const [year, month, day] = value.split('-')
              return `${day}/${month}/${year}`
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#ffffff'
          },
          splitLine: {
            lineStyle: {
              color: '#444'
            }
          }
        },
        series: [
          {
            name: this.$t('cashFlow.table.receivable'),
            data: groupedMaturities.map(item => item.pos),
            type: 'bar',
            stack: 'rates',
            itemStyle: {
              color:"#FFC107"
            }
          },
          {
            name: this.$t('cashFlow.table.payable'),
            data: groupedMaturities.map(item => item.neg),
            type: 'bar',
            stack: 'rates',
            itemStyle: {
              color: "#FF6D00"
            }
          }
        ]
      }
    },
  },
  mounted () {
    this.maturitiesCsv = undefined

    const realMaturities = localStorage.getItem('lastRealMaturities')

    if (this.isMockDataOn) {
      this.fetchMaturitiesCashFlow()
    } else if (realMaturities) {
      this.maturities = JSON.parse(realMaturities)
    } 
  },
  methods: {
    ...mapActions(useRiskStore, [
      "saveMaturities",
      "downloadMaturities",
      'setShouldRefreshMaturities',
      'refreshMaturities'
    ]),
    importMaturities () {
      const file = this.maturitiesCsv
      if (!file) {
        this.snackbarError = true
        this.snackbarMsg = this.$t('cashFlow.chooseFile')
        this.dialog = false
        return
      }
      this.loadingPut = true
      const payload = {
        file: file
      }
      this.saveMaturities(payload)
        .then(() => {
          this.refreshMaturities()
          this.setShouldRefreshMaturities(true)
          localStorage.removeItem('lastExposureItems')
          localStorage.removeItem('lastHedgingItems')
          localStorage.removeItem('lastExposurePeriods')
          this.snackbarSuccess = true
          this.uploadSuccess = true
        })
        .catch ((error) => {
          this.dialog = false
          this.snackbarError = true
          if (error.response) {
            const snackbarText = error.response.data.detail
            this.snackbarMsg = snackbarText
          }
          else {
            this.snackbarMsg = this.$t('cashFlow.importError')
          }
          console.log(error)
        })
        .finally(() => {
          this.loadingPut = false
        })
    },
    fetchMaturitiesCashFlow() {
      this.loadingGet = true

      this.refreshMaturities()
        .catch((error) => {
          console.log(error)
          this.snackbarError = true
          this.snackbarMsg = this.$t('cashFlow.reloadError')
        })
        .finally(() => {
          this.loadingGet = false
        })
    },
    changeFile (file) {
      this.maturitiesCsv = file
    },
    exportCurrencyMaturities () {
      this.loadingDownload = true
      this.downloadMaturities()
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/csv" })
          const link = document.createElement("a")
          link.href = window.URL.createObjectURL(blob)
          link.download = "maturities.csv"
          link.click()
        })
        .catch((error) => {
          console.log(error)
          if (!error) {
            return
          }
          this.snackbarError = true
          if (error.response) {
            this.snackbarMsg = error.response.data
          }
          else {
            this.snackbarMsg = this.$t('cashFlow.exportError')
          }
          console.log(error)
        })
        .finally(() => {
          this.loadingDownload = false
        })
    },
    showDialog () {
      this.dialog = true
    },
  }
}
</script>

<style scoped>
.chart {
  max-width: 1940px;
  min-width: 100px;
  /* width: 1940px; */
  width: 100%;
  min-height: 100px;
  max-height: 3000px;
  height: 100%;
}
</style>